import React, { Fragment, useState, useRef, useEffect } from "react"
import { accessRole } from "../../../../../helpers/access_role"
import apiResponse from "../../../../../services/apiResponse"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Input, Label,
} from "reactstrap"
import Shimmer from "react-shimmer-effect";

import TablePrimaryComponent from './Components/TablePrimaryComponent'

import IndexBloc from './Blocs/IndexBloc'

const IndexView = (props) => {

    const activeRef = useRef();
    const indexBloc = new IndexBloc()

    const [detail, setDetail] = useState([])

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()

    useEffect(() => {
        indexBloc.fetchEmployee({ uuid: props.uuid })
        indexBloc.employeeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    setDetail(result.data.response)
                    break;
                default:
                    break;
            }
        })
    }, [])

    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <div className="float-end">
                        {
                            (accessRole('create')) ?
                                <Link to="?create">
                                    <Button color="primary">Koreksi Kehadiran</Button>
                                </Link>
                            : null
                        }
                        </div>
                        <CardTitle>Daftar Koreksi Kehadiran</CardTitle>
                        <CardSubtitle className="mb-3">
                            Kelola Koreksi Kehadiran
                        </CardSubtitle>
                        <hr />
                        <Row className="mb-1">
                            <label className="col-md-3">
                                NIP
                            </label>
                            <Col md="9">
                                {
                                    detail ?
                                        <>{detail.employee_nip !== "" ? detail.employee_nip : '-'}</>
                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                }
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Nama
                            </label>
                            <Col md="9">
                                {
                                    detail ?
                                        <>{detail.employee_name !== "" ? detail.employee_name : '-'}</>
                                    : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                }
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Jabatan
                            </label>
                            <Col md="9">
                                {
                                    detail ?
                                        <>{detail.employee_current_position_name !== "" ? detail.employee_current_position_name : '-'}</>
                                    : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                }
                            </Col>
                        </Row>

                        <Row className="mb-1">
                            <label className="col-md-3">
                                Unit Kerja
                            </label>
                            <Col md="9">
                                {
                                    detail ?
                                        <>{detail.employee_current_work_unit_name !== "" ? detail.employee_current_work_unit_name : '-'}</>
                                    : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                }
                            </Col>
                        </Row>
                        <hr/>
                        <TablePrimaryComponent uuid={props.uuid} ref={activeRef} handleInactiveSuccess={reloadInactiveRef} />
                        <Link to="/izinpegawai/koreksikehadiran.html">
                            <Button color="success">Kembali</Button>
                        </Link>
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )

}

export default IndexView